export const getSafeAnnotationXY = (predictedAnnotationLeftEdge: number, predictedAnnotationTopEdge: number, rect: { width: number; height: number }, annotationDimensions: { width: number; height: number; }) => {
	return {
		x: predictedAnnotationLeftEdge < 0 ? 0 : predictedAnnotationLeftEdge > rect.width - annotationDimensions.width ? rect.width - annotationDimensions.width : predictedAnnotationLeftEdge,
		y: predictedAnnotationTopEdge < 0 ? 0 : predictedAnnotationTopEdge > rect.height - annotationDimensions.height ? rect.height - annotationDimensions.height : predictedAnnotationTopEdge
	}
}
